/**
 * Client helpers for Glowkit newsletter (Netlify Functions + Blobs).
 */

const DEFAULT_SUBSCRIBE_PATH = "/api/subscribe";

export function isNewsletterEnabled() {
  const flag = process.env.REACT_APP_NEWSLETTER_ENABLED;
  if (flag === undefined || flag === "") return true;
  return flag === "true" || flag === "1";
}

/**
 * @param {{ email: string, consent: boolean, leadMagnet?: string, source?: string }} input
 */
export async function subscribe({ email, consent, leadMagnet, source } = {}) {
  if (!isNewsletterEnabled()) {
    throw new Error("Newsletter disabilitata (REACT_APP_NEWSLETTER_ENABLED).");
  }
  const res = await fetch(DEFAULT_SUBSCRIBE_PATH, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      email,
      consent: Boolean(consent),
      leadMagnet: leadMagnet || undefined,
      source: source || "footer",
    }),
  });

  let data = {};
  try {
    data = await res.json();
  } catch {
    data = {};
  }

  if (!res.ok) {
    const err = new Error(data.error || `Subscribe failed (${res.status})`);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}
